import data from '../app/insights/data.json';
import { getUniqueValues } from '@/helpers/insights';
import { IInsightListItem } from '@/interfaces/insights';

export const DEFAULT_TAB_NAME = {
  value: 'View all',
  label: 'View all',
};

export const TABS_SELECTOR_ID = 'insights-tabs';

export const ITEMS_PER_PAGE = {
  desktop: 15,
  tablet: 6,
  mobile: 5,
};

export const WEBINAR_STATUSES = ['past', 'future', 'webinar'];

export const DEFAULT_SEARCH_PARAMS = {
  category: 'category',
  tags: 'tags',
  page: 'page',
};

const { list: insightsList } = data.insights;
const getAllTags = (list: IInsightListItem[]) =>
  list
    .flatMap((item) => item.tags.map((tag) => tag.title))
    .filter((tag) => !WEBINAR_STATUSES.includes(tag.toLowerCase()));

export const allInsightsUniqueTags = getUniqueValues(getAllTags(insightsList)).sort();
